import React, { Component } from "react";

import { Icon as LegacyIcon } from "@ant-design/compatible";

import { UserOutlined } from "@ant-design/icons";

// antd 的相关组件
import { Layout, Tabs, message, Menu, Dropdown, Avatar } from "antd";

import _ from "lodash";

// layout布局自定义样式
import "../../assets/stylus/com/layout/layout.styl";

// 导入自定义的logo
import PropTypes from "prop-types";
import logo from "../../assets/img/logo_white.svg";

// 导入属性类型工具

// 导入 框架示例菜单组件
import ExampleMenu from "../display/menu/exampleMenu";

// 导入配置的Tab组
import ExampleFrame from "../../tabs/exampleTabs";

import { updatePanelsInfo } from "../../state/action/comAction";

// 定义组件对应的子组件

const { Header, Content, Footer, Sider } = Layout;
const TabPane = Tabs.TabPane;

/*
 * layout(Tab) 框架布局
 * @class ScLayout
 * @constructor
 * @property {Array} panes 内容区域标签页数组
 * @property {Object} state 组件类的状态
 *
 * */

class ScLayoutTabExample extends Component {
  // 获取父组件路由传递的属性
  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    const panes = [];
    window.LayoutTab = this;
    this.state = {
      activeKey: null, // 当前显示的tab标签
      panes, // 内容区域中存在的标签数组
    };

    // 获取所有 key - Tab 对应信息
    this.Frame = new ExampleFrame(this.addTab.bind(this));
  }

  componentWillMount() {
    this.initStore();
  }

  componentDidMount() {
    this.resizeAutoHeight();
  }

  // 添加tab页面
  addTab = (e, param) => {
    let canAdd = !0;
    const panes = this.state.panes;
    const contentKey = `${e.key}`;
    const activeKey = param && param.keyId ? `${e.key}${param.keyId}` : `${e.key}`;
    // 设置最大显示窗口数量
    if (panes.length > 8) {
      message.warn("请关闭多余窗口！", 1);
      return;
    }
    for (const p of panes) {
      if (p.key === activeKey) {
        canAdd = !1;
      }
    }

    if (canAdd) {
      window.LayoutTab["tabParam"] = param || "";
      panes.push({
        title: e.domEvent && e.domEvent.target ? e.domEvent.target.textContent : e.titleText,
        content: this.Frame[contentKey],
        key: activeKey,
        param,
      });
      this.setState({ panes, activeKey });
      this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
    } else {
      window.LayoutTab["tabParam"] = param || "";
      const closeEnable = activeKey !== "010101";
      const removeIndex = _.findIndex(panes, (cp) => {
        return cp.key === activeKey;
      });
      panes.splice(removeIndex, 1);
      const replaceTitle = e.domEvent && e.domEvent.target
        ? e.domEvent.target.textContent : e.titleText;
      this.setState({ panes, activeKey }, () => {
        panes.splice(removeIndex, 0, {
          title: replaceTitle,
          content: this.Frame[contentKey],
          key: activeKey,
          closable: closeEnable,
          param,
        });
        this.setState({ panes: [...panes], activeKey });
        this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
      });
    }
    // if (canAdd) {
    //   panes.push({
    //     title: e.domEvent ? e.domEvent.target.textContent : e.titleText,
    //     content: this.Frame[contentKey],
    //     key: activeKey
    //   });
    //   this.context.store.dispatch(initPanels('project', panes, activeKey, param));
    //   this.setState({
    //     panes,
    //     activeKey
    //   });
    // } else {
    //   this.context.store.dispatch(setParamPanels('project', param));
    //   this.setState({
    //     activeKey
    //   });
    // }
    // 将panes 作为公共对象
  }

  // 重置自适应内容高度

  resizeAutoHeight() {
    const minH = window.innerHeight - 178;
    document.querySelector(".sc-content-auto").style.minHeight = `${minH}px`;
  }

  // 初始化并监听状态数据变化

  initStore() {
    const store = this.context.store;
    let panelsInfo = null;
    store.subscribe(() => {
      if (panelsInfo) {
        return;
      }
      panelsInfo = store.getState().panelsInfo;
      this.setState({
        panes: panelsInfo.openPanels,
        activeKey: panelsInfo.activeKey,
      });
    });
  }

  exit() {
    if (window.sessionStorage.getItem("token")) {
      window.sessionStorage.removeItem("token");
    }
    if (window.sessionStorage.getItem("name")) {
      window.sessionStorage.removeItem("name");
    }
    this.context.router.history.push("login");
  }

  // tab 回调事件设置

  onEdit = (targetKey, action) => {
    this[action](targetKey);
  }

  onChange = (activeKey) => {
    if (window.LayoutTab) {
      window.LayoutTab.tabId = "";
    }
    const currentPanels = this.context.store.getState().panelsInfo.openPanels;
    this.setState({
      activeKey,
    });
    const activePanel = _.find(currentPanels, (cp) => {
      return cp.key === activeKey;
    });
    if (activePanel) {
      window.LayoutTab["tabParam"] = activePanel.param || "";
    }
  }

  remove = (targetKey) => {
    let activeKey = this.state.activeKey;
    let lastIndex;
    this.state.panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const panes = this.state.panes.filter((pane) => pane.key !== targetKey);
    if (lastIndex >= 0 && activeKey === targetKey) {
      activeKey = panes[lastIndex].key;
    }
    this.setState({
      panes,
      activeKey,
    });
    this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
    // this.context.store.dispatch(initPanels(panes, activeKey));
  }

  render() {
    const menu = (
      <Menu>
        <Menu.Item>
          <a href="javascript:void(0);" onClick={this.exit.bind(this)}>
            注销用户
          </a>
        </Menu.Item>
      </Menu>
    );
    return (
      <Layout>
        <Sider
          width="186"
          onCollapse={(collapsed, type) => {
            console.debug(collapsed, type);
          }}>
          <div className="logo">
            <img src={logo} className="App-logo" alt="logo" />
          </div>
          <ExampleMenu addTab={this.addTab} Frame={this.Frame} />
        </Sider>
        <Layout className="sc-oms-pagearea">
          <Header className="sc-oms-header">
            <Dropdown overlay={menu}>
              <a className="ant-dropdown-link" href="javascript:void(0)">
                <Avatar
                  icon={<UserOutlined />}
                  size="small"
                  shape="square"
                  style={{ backgroundColor: "#1c7cff" }}
                />
                <span className="username">{window.sessionStorage.getItem("name")}</span>
                <LegacyIcon type="down"></LegacyIcon>
              </a>
            </Dropdown>
          </Header>
          <Content>
            <div className="sc-content-auto">
              <Tabs
                type="editable-card"
                hideAdd
                animated
                activeKey={this.state.activeKey}
                onChange={this.onChange}
                onEdit={this.onEdit}>
                {this.state.panes.map((pane) => (
                  <TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
                    {pane.content}
                  </TabPane>
                ))}
              </Tabs>
            </div>
            <div className="sc-content-footer"></div>
          </Content>
          <Footer className="sc-oms-footer">
            COPYRIGHT &copy;2018 All rights reserved. 苏ICP 备 14056214 号
          </Footer>
        </Layout>
      </Layout>
    );
  }
}

export default ScLayoutTabExample;



// WEBPACK FOOTER //
// ./src/AntD/components/layout/scLayoutTabExample.js